import React, { PropsWithChildren } from "react";
import styles from "./InputContainer.module.scss";

/* Components */
import { Separator } from "../Separator/Separator";
import SVG from "react-inlinesvg";

/* Assets */
import dropdown from "../../../../assets/dropdown.svg";
import { Validity } from "../../interfaces/tip/Validations";
import classnames from "classnames";
interface InputContainerProps {
  label: string;
  isDropdown?: boolean;
  validity?: Validity | false;
}

export const InputContainer: React.FC<
  InputContainerProps & PropsWithChildren
> = ({ label, children, isDropdown = false, validity }) => {
  const isValid = validity ? validity.isValid : true;
  const cx = classnames.bind(styles);
  return (
    <div
      className={cx(
        styles.InputContainer,
        isValid ? styles.valid : styles.invalid
      )}
    >
      <span className={styles.label}>{label}</span>
      {isDropdown ? (
        <div className={styles.dropdownChildren}>
          {children}
          <SVG className={styles.dropdown} src={dropdown} fill="#242424" />
        </div>
      ) : (
        <>{children}</>
      )}
      <Separator />
    </div>
  );
};
